import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Box } from '@mui/material';

const Footer = () => {
  const [translate] = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box sx={{ minHeight: '5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant='caption' textAlign='center'>
        {translate('text', { year: currentYear })}
      </Typography>
    </Box>
  );
};

export default Footer;
